export const decodeJWT = (token: string) => {
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    return decoded;
  } catch (error) {
    console.error('Erro ao decodificar JWT:', error);
    return null;
  }
};

export const extractNameFromToken = (token: string): string | null => {
  const decoded = decodeJWT(token);
  return decoded?.given_name || decoded?.name || decoded?.preferred_username || null;
};